import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EmploymentStatusListType } from 'types/employmentStatus';
import { EMPLOYMENT_STATUS_CODE_AND_QUERY } from 'components/SearchSideBar/constants';
import { HooksArgument } from 'components/SearchSideBar/types';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 雇用形態の初期配列生成処理
 * @param param.jobCountData 求人件数
 * @param param.queries クエリ
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @returns 初期配列
 */
export const createInitialEmploymentStatusList = ({
  jobCountData,
  queries,
  savedSearchCondition,
  featuredSearchCondition,
}: HooksArgument) => {
  const idList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialList: EmploymentStatusListType[] = [
    {
      id: OP_SEARCH_ITEMS.regularEmployee.id,
      name: OP_SEARCH_ITEMS.regularEmployee.name,
      isChecked: idList
        ? idList.some((query) => query === OP_SEARCH_ITEMS.regularEmployee.id)
        : false,
      value: EMPLOYMENT_STATUS_CODE_AND_QUERY.FULL_TIME.code,
      jobCount: findJobCount(
        jobCountData.employmentStatusList,
        EMPLOYMENT_STATUS_CODE_AND_QUERY.FULL_TIME.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.contractEmployee.id,
      name: OP_SEARCH_ITEMS.contractEmployee.name,
      isChecked: idList
        ? idList.some((query) => query === OP_SEARCH_ITEMS.contractEmployee.id)
        : false,
      value: EMPLOYMENT_STATUS_CODE_AND_QUERY.CONTRACT.code,
      jobCount: findJobCount(
        jobCountData.employmentStatusList,
        EMPLOYMENT_STATUS_CODE_AND_QUERY.CONTRACT.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.other.id,
      name: OP_SEARCH_ITEMS.other.name,
      isChecked: idList
        ? idList.some(
            (query) =>
              query ===
              EMPLOYMENT_STATUS_CODE_AND_QUERY.OTHER.query.find(
                (item) => item === query
              )
          )
        : false,
      value: EMPLOYMENT_STATUS_CODE_AND_QUERY.OTHER.code,
      jobCount: findJobCount(
        jobCountData.employmentStatusList,
        EMPLOYMENT_STATUS_CODE_AND_QUERY.OTHER.code
      ),
    },
  ];

  return initialList;
};
